import React from 'react'
import TablePage from "../../common/TablePage";
import { bindActionCreators } from "redux";
import * as Actions from "../../actions/Actions";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import strings from "../../localization";
import { withSnackbar } from "notistack";
import AddPrincipal from './AddPrincipal';
import EditPrincipal from './EditPrincipal';
import ViewPrincipal from './ViewPrincipal';
import { deletePrincipal, getDeletedPrincipals, getPrincipals, restorePrincipals } from '../../services/principal/PrincipalService';


class PrincipalList extends TablePage {

  tableDescription = [
    { key: 'name', label: strings.principalList.name, sort: 'name' },
    { key: 'dateCreated', label: strings.principalList.dateCreated, transform: 'renderColumnDate', sort: 'dateCreated' },
  ];

  constructor(props) {
    super(props);

    this.state.sortBy = "name,ASC";
    this.state.showDeleted = false;
  }

  fetchData() {
    let data = {
      searchParam: this.state.searchData.search,
      page: this.state.searchData.page - 1,
      size: this.state.searchData.perPage,
      companyId: this.state.companyId,
      sort: this.state.sortBy,
      userId: this.props.auth.user.id
    }

    {
      (this.state.companyId != undefined && !this.state.showDeleted) &&
      getPrincipals(data).then(response => {
        if (!response.ok) {
          return;
        }

        this.setState({
          tableData: response.data.entities,
          total: response.data.total,
        });
      });
    }

    {
      (this.state.companyId != undefined && this.state.showDeleted) &&
      getDeletedPrincipals(data).then(response => {
          if (!response.ok) {
            return;
          }
          this.setState({
            tableData: response.data.entities,
            total: response.data.total,
          });
        });
    }
  }

  usePermissions(){
    let data = {
      userId: this.props.auth.user.id,
      category: "Налогодавци"
    }
    this.getPermissionsS(data);
    this.showAdd(this.props.showAdd);
    this.showRemove(this.props.remove);
    this.showEdit(this.props.showEdit);
    this.showView(this.props.showView);
    this.removedItemsShow(this.props.removedItemsShow);

  }

  componentDidMount() {
    this.usePermissions()
    this.setState({
      companyId: this.props.auth.user.company.id
    }, () => { this.fetchData(); })
  }

  handleDeletedChange(){
    this.setState({
      showDeleted : !this.state.showDeleted
    },() =>{ this.fetchData(); })
    
  }

  componentWillReceiveProps(nextProps) {
    strings.setLanguage(nextProps.auth.user.language);
    this.tableDescription = [
      { key: 'name', label: strings.principalList.name, sort: 'name' },
      { key: 'dateCreated', label: strings.principalList.dateCreated, transform: 'renderColumnDate', sort: 'dateCreated' },
    ];
  }

  getPageHeader() {

    return <h1>{strings.principalList.pageTitle}</h1>;
  }

  renderAddContent() {

    return <AddPrincipal uemail={this.props.auth.user.email} cid={this.state.companyId} onCancel={this.onCancel} onFinish={this.onFinish} />
  }

  renderEditContent() {

    return <EditPrincipal uemail={this.props.auth.user.email} cid={this.state.companyId} isDisabled={false} id={this.state.selectedItem.id} onCancel={this.onCancel} onFinish={this.onFinish} auth={this.props.auth} />
  }

  renderViewContent() {

    return <ViewPrincipal id={this.state.selectedItem.id} cid={this.state.companyId} isDisabled={true} onCancel={this.onCancel} onFinish={this.onFinish} auth={this.props.auth} />
  }

  delete(item) {

    this.setState({
      lockTable: true
    });

    deletePrincipal(item.id, this.props.auth.user.id).then(response => {

      if (response && !response.ok) {
        this.onFinish(null);
        return;
      }

      this.props.enqueueSnackbar(strings.principalList.deleted, { variant: 'success' });

      this.onFinish(item);
      this.cancelDelete();

      this.setState({
        lockTable: false
      });
    });
  }

  transformRequest(data) {
    return {
        ...data,
        userEmail: this.props.auth.user.email,
        companyId: this.state.companyId
    }
}
  restore(item){
    
    restorePrincipals(this.transformRequest(item)).then(response => {
      if (response && !response.ok) {
        this.onFinish(null);
        return;
      }
      this.setState({
        showDeleted : !this.state.showDeleted,
      },() =>{ this.fetchData(); })
    })
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    changeFullScreen: Actions.changeFullScreen
  }, dispatch);
}

function mapStateToProps({ menuReducers, authReducers, siteDataReducers }) {
  return { menu: menuReducers, auth: authReducers, siteData: siteDataReducers };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(PrincipalList)));